export const ISR_TIMEOUT = process.env.ENV === 'production' ? 300 : 10;
